import { useTranslations } from "next-intl";

import { SuggestionGridOption } from "@/components/suggestions/list/SuggestionGridOption";
import { getSuggestionHotkey } from "@/components/suggestions/list/utils";
import { twMerge } from "@/utils/twMerge";

import type { SuggestionsGroup } from "@/components/suggestions/types";
import type { DocumentModel } from "@/models/DocumentModel";
import type { SuggestionsModel } from "@/models/SuggestionsModel";

type Props = {
  doc: DocumentModel;
  suggestions: SuggestionsModel;
  group: SuggestionsGroup;
  showHotKeys?: boolean;
  listId: string | null;
};

export function SuggestionsGrid({ doc, suggestions, group, showHotKeys, listId }: Props) {
  const t = useTranslations("suggestions");

  return (
    <ul
      data-testid="suggestions-grid"
      className={twMerge(
        "px-1 py-1 grid gap-1 grid-cols-4",
        group.name === "phantomHint" && "grid-cols-2",
      )}
      aria-label={t(`view.${group.view}`)}
    >
      {group.items.map((item, itemIndex) => {
        const flatIndex = (group.startIndex ?? 0) + itemIndex;
        const hotkey = showHotKeys ? getSuggestionHotkey(flatIndex) : undefined;

        return (
          // eslint-disable-next-line react/no-array-index-key
          <li key={`${item.type}-${itemIndex}`}>
            <SuggestionGridOption
              index={flatIndex}
              doc={doc}
              suggestions={suggestions}
              suggestion={item}
              action={hotkey}
              isHighlighted={group.name === "symbols"}
              listId={listId}
            />
          </li>
        );
      })}
    </ul>
  );
}
